import React from 'react';
import {
    Select,
    SelectChangeEvent, MenuItem, ListItemText,
} from '@mui/material';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import { accountService, IApiManufactory, IApiSector } from '@tap/data-providers';
import { IComponentCss } from '@tap/mui-ui';

const css: IComponentCss = {
    checkIcon: {
        height: '20px',
        width: '20px',
        marginRight: '5px',
    },
    menuItem: {
        padding: '5px 6px',
    },
}

export const useDepartmentField = (formValue, setFormValue) => {

    const [manufactories, setManufactories] = React.useState<IApiManufactory[]>([]);
    const [sectors, setSectors] = React.useState<IApiSector[]>([]);

    React.useEffect(() => {
        accountService.getDepartmentListByRole('D').then((res) => {
            setManufactories(res);
            setSectors(
                res.map(m => {
                    return m.sectors.map(s => ({ ...s, name: `${m.name}.${s.name}` }));
                }).flat(),
            );
        });
    }, []);


    // Цеха: обработчик для выпадающего списка 
    const handleChangeSelectedManufactory = (e: SelectChangeEvent<string>) => {
        const manufactoryName = e.target.value as string;
        const selectedManufactory = manufactories.find(m => m.name === manufactoryName);
        setSectors(selectedManufactory.sectors.map(s => ({ ...s, name: `${selectedManufactory.name}.${s.name}` })));
        setFormValue({ manufacture: manufactoryName, sector: '', id: '' });
    };


    // Участки: обработчик для выпадающего списка 
    const handleChangeSelectedSector = (e: SelectChangeEvent<number>) => {
        const departmentId = e.target.value as number;

        const selectedManufactory = manufactories.find(m => m.sectors.filter(s => s.id === departmentId).length > 0);
        const selectedSector = selectedManufactory.sectors.find(s => s.id === departmentId);

        setFormValue({ manufacture: selectedManufactory.name, sector: selectedSector.name, id: departmentId });
    };

    return { manufactories, sectors, formValue, handleChangeSelectedManufactory, handleChangeSelectedSector }

}

export const DepartmentField = ({ value, onChange }: { value: any, onChange: (newValue: any) => void }) => {

    const { manufactories, sectors, formValue, handleChangeSelectedManufactory, handleChangeSelectedSector } = useDepartmentField(value, onChange);


    return (
        <>
            {/* <FieldWrap label={'Цех'}>
                <FormControl fullWidth sx={css.select}>
                    <Select
                        size='small'
                        value={formValue.manufacture}
                        onChange={handleChangeSelectedManufactory}
                        displayEmpty={true}
                        renderValue={() => formValue.manufacture}
                    >
                        {manufactories.map(manufactory =>
                            <MenuItem
                                key={manufactory.name}
                                value={manufactory.name}
                                sx={css.menuItem}
                            >
                                <CheckOutlinedIcon
                                    sx={{
                                        ...css.checkIcon,
                                        visibility: formValue.manufacture === manufactory.name ? 'visible' : 'hidden'
                                    }}
                                />
                                <ListItemText primary={manufactory.name} />
                            </MenuItem>
                        )}
                    </Select>
                </FormControl>
            </FieldWrap> */}

            {/* Выпадающий список: Участки */}
            <Select
                className='field-short'
                size='small'
                value={formValue.id}
                onChange={handleChangeSelectedSector}
                displayEmpty={true}
                renderValue={() => formValue.sector ? `${formValue.manufacture}.${formValue.sector}` : formValue.sector}
            >
                {sectors.map(sector =>
                    <MenuItem
                        key={sector.id}
                        value={sector.id}
                        sx={css.menuItem}
                    >
                        <CheckOutlinedIcon
                            sx={{
                                ...css.checkIcon,
                                visibility: formValue.id === sector.id ? 'visible' : 'hidden',
                            }}
                        />
                        <ListItemText primary={sector.name} />
                    </MenuItem>,
                )}
            </Select>
        </>

    );

}